import { useInvoiceService } from '../service/invoice.service';

const resource = 'pricelists';

const useInvoice = () => {
  const {
    getById,
    getAwbById,
    getPayment,
    getSummary,
    getDetailAwbInvoice,
  } = useInvoiceService();

  function getInvoiceById(id: string) {
    return getById(id);
  }

  function getSummaryById(id: string) {
    return getSummary(id);
  }

  function getInvoiceAwbById(id: string) {
    return getAwbById(id);
  }

  function getPaymentById(id: string) {
    return getPayment(id);
  }

  function getDetailAwb(id: string) {
    return getDetailAwbInvoice(id);
  }

  return {
    resource,
    getInvoiceById,
    getInvoiceAwbById,
    getSummaryById,
    getPaymentById,
    getDetailAwb,
  };
};

export default useInvoice;
